import { styled } from '@mui/material/styles';
import React from 'react';
import classNames from 'classnames';
import { chooseTourImageLink } from '@lialo/core/lib/utils/helper/image-link';
import { useCurrentSlide } from './ImageSlider';

const PREFIX = 'AspectRatioImage';

const classes = {
  container: `${PREFIX}-container`,
  img: `${PREFIX}-img`,
  animation: `${PREFIX}-animation`,
  gradient: `${PREFIX}-gradient`,
};

const Root = styled('div')(() => ({
  [`&.${classes.container}`]: {
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    zIndex: 1,
  },
  [`& .${classes.img}`]: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
  [`& .${classes.animation}`]: {
    animationName: 'zoom',
    animationDuration: '15s',
    animationTimingFunction: 'ease-out',
    animationFillMode: 'forwards',
  },
  '@keyframes zoom': {
    '0%': {
      transform: 'translate(5%, 5%) scale(1.2)',
    },
    '100%': {
      transform: 'translate(0%, 0%) scale(1.0)',
    },
  },
}));

interface IProps {
  originalSrc: string;
  alt?: string;
  className?: string;
  width: number;
  aspectRatio: string; // e.g. '16 / 9'
  slideNumber: number;
  animate?: boolean;
}

export const SliderImage = ({ className, aspectRatio, originalSrc, width, alt, slideNumber, animate }: IProps) => {
  const currentSlide = useCurrentSlide();
  const visible = slideNumber === currentSlide;

  return (
    <Root style={{ aspectRatio: aspectRatio }} className={classes.container}>
      <img
        className={classNames(className, classes.img, {
          [classes.animation]: visible && animate === true,
        })}
        src={chooseTourImageLink(originalSrc, width)}
        alt={alt ?? ''}
      />
    </Root>
  );
};
